<div class="dashboard-layout-container">
  <!-- Sidebar Navigation -->
  <aside class="sidebar" [class.collapsed]="sidebarCollapsed">
    <div class="logo-section" style="margin: -24px -24px 32px -24px; padding: 24px 10px; border-bottom: 1px solid var(--border-color); display: flex; width: calc(100% + 48px); align-items: center; gap: 4px; background: white;">
      <div class="logo-banner-wrapper" *ngIf="!sidebarCollapsed" style="flex-grow: 1; max-width: 92%;">
        <img src="https://www.grihaindia.org/themes/custom/grihacustomtheme/images/GRIHA-NEWLOGO.png" alt="GRIHA Council" style="width: 100%; height: auto; display: block;" />
      </div>
      <div class="logo-circle" *ngIf="sidebarCollapsed" style="flex-shrink: 0; background: transparent; border: none; box-shadow: none; width: 36px; height: 48px; overflow: hidden; position: relative; border-radius: 0; margin: 0 auto;">
        <div style="width: 200px; height: 48px; background-image: url('https://www.grihaindia.org/themes/custom/grihacustomtheme/images/GRIHA-NEWLOGO.png'); background-size: contain; background-repeat: no-repeat; background-position: left center; position: absolute; left: 0; top: 0;"></div>
      </div>
      <button class="collapse-toggle-btn" (click)="sidebarCollapsed = !sidebarCollapsed" [title]="sidebarCollapsed ? 'Expand Sidebar' : 'Collapse Sidebar'">
        <svg *ngIf="sidebarCollapsed" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
        <svg *ngIf="!sidebarCollapsed" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      </button>
    </div>

    <nav style="margin-bottom: 24px;">
      <p class="nav-label">Rating Frameworks</p>
      <ul class="nav-list">
        <li class="nav-item" *ngFor="let app of apps">
          <button 
            class="nav-button" 
            [class.active]="activeAppCode === app.code"
            (click)="selectApp(app.code)"
            [title]="app.name">
            <span class="nav-btn-icon">{{ app.icon }}</span>
            <span class="nav-btn-text">{{ app.name }}</span>
          </button>
        </li>
      </ul>
    </nav>

    <!-- Eco Tips Panel -->
    <div class="eco-tips-card">
      <div class="tips-header">
        <span class="tip-icon">💡</span>
        <span class="tip-label">Green Fact</span>
      </div>
      <p class="tip-text">Green buildings certified by GRIHA achieve up to 30% to 50% reduction in energy consumption and 40% reduction in water usage compared to conventional buildings.</p>
    </div>

    <div class="sidebar-footer">
      <div class="status-dot" [class.loading]="loading" [class.error]="errorMsg !== ''"></div>
      <span class="status-text">{{ loading ? 'Syncing...' : errorMsg !== '' ? 'Server Error' : 'System Online' }}</span>
    </div>
  </aside>

  <!-- Main Work Area -->
  <main class="main-content">
    <header class="header">
      <div class="header-top">
        <div class="title-area">
          <div>
            <h1 style="display: flex; align-items: center; gap: 8px;">{{ getActiveApp().name }} Dashboard</h1>
            <p>{{ getActiveApp().desc }}</p>
          </div>
        </div>
        <div class="badge-row">
          <span class="app-badge">{{ activeAppCode }}</span>
        </div>
      </div>
    </header>

    <!-- Mobile Rating Framework Selector -->
    <div class="mobile-framework-selector">
      <button 
        *ngFor="let app of apps" 
        class="mobile-pill" 
        [class.active]="activeAppCode === app.code" 
        (click)="selectApp(app.code)">
        <span class="mobile-pill-icon">{{ app.icon }}</span>
        <span class="mobile-pill-text">{{ app.name }}</span>
      </button>
    </div>

    <div class="loading-screen" *ngIf="loading && projects.length === 0">
      <div class="spinner"></div>
      <p>Loading dashboard data...</p>
    </div>

    <div class="error-screen" *ngIf="!loading && errorMsg">
      <h3>Connection Failed</h3>
      <p>{{ errorMsg }}</p>
      <button class="retry-button" (click)="selectApp(activeAppCode)">Retry Connection</button>
    </div>

    <div *ngIf="!loading && !errorMsg">
      <!-- Overview Statistics Grid -->
      <section class="stats-grid">
        <div class="stat-card">
          <div class="stat-header">
            <span class="stat-label">Total Projects</span>
            <div class="stat-svg-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather">
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
              </svg>
            </div>
          </div>
          <span class="stat-val">{{ stats?.totalProjects || 0 }}</span>
        </div>

        <div class="stat-card">
          <div class="stat-header">
            <span class="stat-label">Initiated</span>
            <div class="stat-svg-icon initiated">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather">
                <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
              </svg>
            </div>
          </div>
          <span class="stat-val">{{ stats?.byStatus?.['INITIATED'] || 0 }}</span>
        </div>

        <div class="stat-card">
          <div class="stat-header">
            <span class="stat-label">Submitted</span>
            <div class="stat-svg-icon submitted">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
                <polyline points="10 9 9 9 8 9"></polyline>
              </svg>
            </div>
          </div>
          <span class="stat-val">{{ stats?.byStatus?.['SUBMITTED'] || stats?.byStatus?.['PENDING_SUBMISSION'] || 0 }}</span>
        </div>

        <div class="stat-card">
          <div class="stat-header">
            <span class="stat-label">Certified</span>
            <div class="stat-svg-icon certified">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather">
                <circle cx="12" cy="8" r="7"></circle>
                <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
              </svg>
            </div>
          </div>
          <span class="stat-val">{{ getStatusCount('CERTIFIED') }}</span>
        </div>

        <div class="stat-card">
          <div class="stat-header">
            <span class="stat-label">Closed</span>
            <div class="stat-svg-icon certified">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
            </div>
          </div>
          <span class="stat-val">{{ getStatusCount('CLOSED') }}</span>
        </div>

        <div class="stat-card">
          <div class="stat-header">
            <span class="stat-label">Rejected</span>
            <div class="stat-svg-icon certified">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="15" y1="9" x2="9" y2="15"></line>
                <line x1="9" y1="9" x2="15" y2="15"></line>
              </svg>
            </div>
          </div>
          <span class="stat-val">{{ getStatusCount('REJECTED') }}</span>
        </div>
      </section>

      <!-- Visual Distribution Charts -->
      <section class="charts-row-container">
        <!-- Row 1: Horizontal Progress Lists -->
        <div class="charts-grid-row-1" [class.two-columns]="activeAppCode === 'ALL'">
          <!-- Column 1: Project Status Distribution -->
          <div class="chart-card">
            <h2>Project Status Distribution</h2>
            <div class="chart-list">
              <div class="chart-item" *ngFor="let item of stats?.byStatus | keyvalue">
                <div class="chart-item-header">
                  <span class="chart-item-label">{{ item.key }}</span>
                  <span class="chart-item-val">{{ item.value }} ({{ ((item.value / stats.totalProjects) * 100) | number:'1.0-0' }}%)</span>
                </div>
                <div class="progress-bar-container">
                  <div class="progress-bar-fill color-status" [style.width.%]="(item.value / stats.totalProjects) * 100"></div>
                </div>
              </div>
              <p class="no-data" *ngIf="!stats?.byStatus || (stats?.byStatus | keyvalue)?.length === 0">No status data available</p>
            </div>
          </div>

          <!-- Column 2: Application Type Distribution (Only shown in 'ALL' mode) -->
          <div class="chart-card" *ngIf="activeAppCode === 'ALL'">
            <h2>Application Type Distribution</h2>
            <div class="chart-list">
              <div class="chart-item" *ngFor="let item of stats?.byApp | keyvalue">
                <div class="chart-item-header">
                  <span class="chart-item-label">{{ item.key }}</span>
                  <span class="chart-item-val">{{ item.value }} ({{ ((item.value / stats.totalProjects) * 100) | number:'1.0-0' }}%)</span>
                </div>
                <div class="progress-bar-container">
                  <div class="progress-bar-fill color-app" [style.width.%]="(item.value / stats.totalProjects) * 100"></div>
                </div>
              </div>
              <p class="no-data" *ngIf="!stats?.byApp || (stats?.byApp | keyvalue)?.length === 0">No application type data available</p>
            </div>
          </div>
        </div>

        <!-- Row 2: Legible Large SVG Graphs with Legends -->
        <div class="charts-grid-row-2">
          <!-- Card 1: Application Type SVG Graph (Only shown in 'ALL' mode) -->
          <div class="chart-card" *ngIf="activeAppCode === 'ALL'">
            <h2>Application Type Distribution (Graph)</h2>
            <div class="svg-chart-container" style="height: auto;">
              <svg viewBox="0 0 550 300" class="svg-chart" width="100%" height="260px">
                <!-- Gridlines and Ticks -->
                <g class="gridlines">
                  <g *ngFor="let tick of getAppChartTicks">
                    <line x1="50" [attr.y1]="tick.y" x2="530" [attr.y2]="tick.y" class="svg-gridline" />
                    <text x="40" [attr.y]="tick.y + 4" class="svg-axis-text" text-anchor="end">{{ tick.label }}</text>
                  </g>
                </g>
                
                <!-- Bars and Values -->
                <g class="bars">
                  <g class="svg-bar-group-static" *ngFor="let bar of getAppChartData">
                    <rect 
                      [attr.x]="bar.x"
                      [attr.y]="bar.y"
                      width="26"
                      [attr.height]="bar.height"
                      rx="4"
                      [attr.fill]="bar.color"
                      class="svg-bar-static"
                    />
                    <text 
                      [attr.x]="bar.textX"
                      [attr.y]="bar.y - 8"
                      class="svg-bar-value-static"
                      text-anchor="middle"
                    >
                      {{ bar.value }}
                    </text>
                    <!-- Legible labels -->
                    <text
                      [attr.x]="bar.textX"
                      y="270"
                      class="svg-bar-label-static"
                      text-anchor="middle"
                    >
                      {{ getShortName(bar.key) }}
                    </text>
                  </g>
                </g>
              </svg>
            </div>

            <!-- Static Legend grid for Application Types -->
            <div class="chart-legend-grid">
              <div class="chart-legend-item" *ngFor="let bar of getAppChartData">
                <span class="legend-dot" [style.background-color]="bar.color"></span>
                <span class="legend-text">
                  <span class="legend-key">{{ bar.key }}</span>
                  <span class="legend-val">{{ bar.value }} ({{ bar.percentage }}%)</span>
                </span>
              </div>
            </div>
          </div>

          <!-- Card 2: Project Status Distribution (Pie/Donut Chart) -->
          <div class="chart-card">
            <h2>Project Status Lifecycle (Donut Chart)</h2>
            <div class="donut-flex-layout">
              <div class="donut-svg-wrapper">
                <svg viewBox="0 0 320 320" class="donut-svg" width="320px" height="320px">
                  <g>
                    <!-- Background circle track -->
                    <circle 
                      cx="160" 
                      cy="160" 
                      r="100" 
                      fill="transparent" 
                      stroke="#f1fcf6" 
                      stroke-width="32"
                    />
                    <!-- Donut segments -->
                    <circle *ngFor="let slice of getStatusPieChartData"
                      cx="160" 
                      cy="160" 
                      r="100" 
                      fill="transparent" 
                      [attr.stroke]="slice.color" 
                      stroke-width="32" 
                      [attr.stroke-dasharray]="slice.dashArray" 
                      [attr.stroke-dashoffset]="slice.dashOffset" 
                      transform="rotate(-90 160 160)"
                      class="donut-segment"
                    />
                    <!-- Central metrics text -->
                    <text x="160" y="162" class="donut-center-val" text-anchor="middle">{{ stats?.totalProjects }}</text>
                    <text x="160" y="186" class="donut-center-lbl" text-anchor="middle">TOTAL PROJS</text>
                  </g>
                </svg>
              </div>

              <!-- Vertical status legends -->
              <div class="donut-legend-side-wrapper">
                <div class="donut-legend-side-item" *ngFor="let slice of getStatusPieChartData">
                  <span class="donut-legend-side-dot" [style.background-color]="slice.color"></span>
                  <span class="donut-legend-side-text">
                    <span class="donut-legend-side-key">{{ slice.key }}</span>
                    <span class="donut-legend-side-val">{{ slice.count }} ({{ slice.percentage }}%)</span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Card 3: Test vs Real Donut (shown only in individual framework view) -->
          <div class="chart-card" *ngIf="activeAppCode !== 'ALL'">
            <h2>Project Mode Distribution</h2>
            <div class="donut-flex-layout">
              <div class="donut-svg-wrapper">
                <svg viewBox="0 0 320 320" class="donut-svg" width="320px" height="320px">
                  <g>
                    <circle cx="160" cy="160" r="100"
                      fill="transparent"
                      stroke="#f1fcf6"
                      stroke-width="32" />
                    <circle *ngFor="let slice of getTestVsRealDonutData"
                      cx="160" cy="160" r="100"
                      fill="transparent"
                      [attr.stroke]="slice.color"
                      stroke-width="32"
                      [attr.stroke-dasharray]="slice.dashArray"
                      [attr.stroke-dashoffset]="slice.dashOffset"
                      transform="rotate(-90 160 160)"
                      class="donut-segment" />
                    <text x="160" y="162" class="donut-center-val" text-anchor="middle">{{ projects.length }}</text>
                    <text x="160" y="186" class="donut-center-lbl" text-anchor="middle">TOTAL PROJS</text>
                  </g>
                </svg>
              </div>
              <div class="donut-legend-side-wrapper">
                <div class="donut-legend-side-item" *ngFor="let slice of getTestVsRealDonutData">
                  <span class="donut-legend-side-dot" [style.background-color]="slice.color"></span>
                  <span class="donut-legend-side-text">
                    <span class="donut-legend-side-key">{{ slice.label }}</span>
                    <span class="donut-legend-side-val">{{ slice.count }} ({{ slice.percentage }}%)</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Framework Test vs Real Breakdown (shown only in ALL FRAMEWORKS dashboard) -->
      <section class="fw-type-section" *ngIf="activeAppCode === 'ALL'" style="margin-bottom: 24px;">
        <h2>Project Mode — By Framework</h2>
        <div class="fw-type-grid">
          <div class="fw-type-card" *ngFor="let fw of getFrameworkTypeData">
            <div class="fw-type-header">
              <span class="fw-type-icon">{{ fw.icon }}</span>
              <span class="fw-type-name">{{ fw.name }}</span>
            </div>
            <div class="fw-type-empty" *ngIf="fw.total === 0">No data</div>
            <div class="fw-type-chart-area" *ngIf="fw.total !== 0">
              <svg viewBox="0 0 100 100" class="fw-donut-svg" width="110" height="110">
                <!-- Track -->
                <circle cx="50" cy="50" r="45"
                  fill="none"
                  stroke="hsl(145, 20%, 92%)"
                  stroke-width="10" />
                <!-- Slices -->
                <circle *ngFor="let slice of fw.slices"
                  cx="50" cy="50" r="45"
                  fill="none"
                  [attr.stroke]="slice.color"
                  stroke-width="10"
                  stroke-linecap="butt"
                  [attr.stroke-dasharray]="slice.dashArray"
                  [attr.stroke-dashoffset]="slice.dashOffset"
                  transform="rotate(-90 50 50)" />
                <!-- Centre total -->
                <text x="50" y="46" text-anchor="middle"
                  class="fw-donut-total">{{ fw.total }}</text>
                <text x="50" y="58" text-anchor="middle"
                  class="fw-donut-label">TOTAL</text>
              </svg>

              <div class="fw-type-legend">
                <div class="fw-legend-item">
                  <span class="fw-legend-dot" style="background:#0ea5e9"></span>
                  <span class="fw-legend-text">
                    <strong>{{ fw.real }}</strong> Live
                  </span>
                </div>
                <div class="fw-legend-item">
                  <span class="fw-legend-dot" style="background:#f97316"></span>
                  <span class="fw-legend-text">
                    <strong>{{ fw.test }}</strong> Demo
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Projects Explorer Table Section -->
      <section class="table-section">
        <h2>Registered Projects Directory</h2>

        <!-- Filters Bar -->
        <div class="filters-bar" style="align-items: center; justify-content: space-between; display: flex;">
          <div style="display: flex; flex-wrap: wrap; gap: 16px; flex-grow: 1;">
            <div class="search-input-wrapper">
              <input 
                type="text" 
                class="search-input" 
                placeholder="Search by project name, code, city, organization..." 
                [value]="searchQuery" 
                (input)="onSearchInput($event)"
              />
            </div>

            <select class="filter-select" *ngIf="activeAppCode === 'ALL'" [value]="appTypeFilter" (change)="onAppTypeChange($event)">
              <option value="">All Applications</option>
              <option *ngFor="let app of availableApps" [value]="app.code">{{ app.name }}</option>
            </select>

            <select class="filter-select" [value]="statusFilter" (change)="onStatusChange($event)">
              <option value="">All Statuses</option>
              <option *ngFor="let status of availableStatuses" [value]="status">{{ status }}</option>
            </select>

            <select class="filter-select" [value]="stateFilter" (change)="onStateChange($event)">
              <option value="">All States</option>
              <option *ngFor="let state of availableStates" [value]="state">{{ state }}</option>
            </select>

            <select class="filter-select" [value]="projectModeFilter" (change)="onProjectModeChange($event)">
              <option value="">All Modes</option>
              <option value="live">Live Mode</option>
              <option value="demo">Demo Mode</option>
            </select>
          </div>

          <button class="export-btn" (click)="exportToCSV()" title="Export Filtered Projects to CSV">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
              <polyline points="7 10 12 15 17 10"></polyline>
              <line x1="12" y1="15" x2="12" y2="3"></line>
            </svg>
            <span>Export Report</span>
          </button>
        </div>

        <!-- Project Table -->
        <div class="table-wrapper">
          <table class="projects-table">
            <thead>
              <tr>
                <th>Code</th>
                <th>Project Name</th>
                <th *ngIf="activeAppCode === 'ALL'">Framework</th>
                <th>Building Type</th>
                <th>Location</th>
                <th>Status</th>
                <th>Project Mode</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let proj of paginatedProjects">
                <td data-label="Code" style="font-family: monospace; font-weight: bold; color: var(--accent-color);">{{ proj.project_code || 'N/A' }}</td>
                <td data-label="Project Name" style="font-weight: 500;">
                  <div>{{ proj.name }}</div>
                </td>
                <td data-label="Framework" *ngIf="activeAppCode === 'ALL'" style="font-weight: 600; font-size: 0.85em; color: var(--accent-color);">
                  {{ proj.app?.name?.toUpperCase() || 'UNKNOWN' }}
                </td>
                <td data-label="Building Type">{{ proj.type || 'N/A' }}</td>
                <td data-label="Location">{{ proj.city }}, {{ proj.state }}</td>
                <td data-label="Status">
                  <span class="badge" 
                    [class.badge-initiated]="proj.status === 'INITIATED'"
                    [class.badge-submitted]="proj.status === 'SUBMITTED' || proj.status === 'PENDING_SUBMISSION'"
                    [class.badge-closed]="proj.status === 'CLOSED' || proj.status === 'CERTIFIED' || proj.status === 'REJECTED'"
                    [class.badge-pending]="proj.status !== 'INITIATED' && proj.status !== 'SUBMITTED' && proj.status !== 'CLOSED' && proj.status !== 'CERTIFIED' && proj.status !== 'REJECTED'">
                    {{ normalizeStatus(proj.status) || 'UNKNOWN' }}
                  </span>
                </td>
                <td data-label="Project Mode">
                  <div class="project-type-cell">
                    <span [class]="isTestProject(proj) ? 'type-badge type-badge-demo' : 'type-badge type-badge-live'">
                      {{ isTestProject(proj) ? 'DEMO' : 'LIVE' }}
                    </span>
                    <label class="type-toggle-label" [title]="isTestProject(proj) ? 'Mark as Live' : 'Mark as Demo'">
                      <input type="checkbox"
                        class="type-toggle-checkbox"
                        [checked]="isTestProject(proj)"
                        (change)="toggleProjectType(proj)" />
                      <span class="type-toggle-switch"></span>
                    </label>
                  </div>
                </td>
                <td data-label="Action">
                  <button class="action-btn" (click)="viewProjectDetails(proj)">Details</button>
                </td>
              </tr>
              <tr *ngIf="paginatedProjects.length === 0">
                <td [attr.colspan]="activeAppCode === 'ALL' ? 8 : 7" class="no-data">No projects found matching the criteria.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination Controls -->
        <div class="pagination-bar">
          <div class="pagination-info">
            Showing {{ filteredProjects.length > 0 ? (currentPage - 1) * pageSize + 1 : 0 }} to 
            {{ (currentPage * pageSize > filteredProjects.length) ? filteredProjects.length : currentPage * pageSize }} 
            of {{ filteredProjects.length }} projects
          </div>

          <div class="pagination-controls">
            <select class="filter-select" style="min-width: 80px; padding: 6px 12px;" [value]="pageSize" (change)="onPageSizeChange($event)">
              <option [value]="5">5 / page</option>
              <option [value]="10">10 / page</option>
              <option [value]="25">25 / page</option>
              <option [value]="50">50 / page</option>
            </select>

            <button class="page-btn" [disabled]="currentPage === 1" (click)="prevPage()">Previous</button>
            <span class="page-number">Page {{ currentPage }} of {{ totalPages }}</span>
            <button class="page-btn" [disabled]="currentPage === totalPages" (click)="nextPage()">Next</button>
          </div>
        </div>
      </section>
    </div>
  </main>
</div>

<!-- Slide-over Drawer for Details -->
<div class="drawer-backdrop" *ngIf="selectedProject" (click)="closeDrawer()">
  <div class="drawer" (click)="$event.stopPropagation()">
    <div class="drawer-header">
      <h3>Project Details</h3>
      <button class="close-btn" (click)="closeDrawer()">&times;</button>
    </div>

    <div class="drawer-body">
      <div class="drawer-section">
        <h4>Basic Information</h4>
        <div class="drawer-grid">
          <div class="grid-item full-width">
            <span class="grid-item-label">Project Name</span>
            <span class="grid-item-val" style="font-size: 16px; color: var(--primary-color);">{{ selectedProject.name }}</span>
          </div>
          <div class="grid-item">
            <span class="grid-item-label">Project Code</span>
            <span class="grid-item-val" style="font-family: monospace;">{{ selectedProject.project_code || 'N/A' }}</span>
          </div>
          <div class="grid-item">
            <span class="grid-item-label">Status</span>
            <span class="grid-item-val">{{ normalizeStatus(selectedProject.status) || 'N/A' }}</span>
          </div>
          <div class="grid-item">
            <span class="grid-item-label">Building Type</span>
            <span class="grid-item-val">{{ selectedProject.type || 'N/A' }}</span>
          </div>
          <div class="grid-item">
            <span class="grid-item-label">Organization</span>
            <span class="grid-item-val">{{ selectedProject.organization || 'N/A' }}</span>
          </div>
        </div>
      </div>

      <div class="drawer-section">
        <h4>Location Details</h4>
        <div class="drawer-grid">
          <div class="grid-item">
            <span class="grid-item-label">City</span>
            <span class="grid-item-val">{{ selectedProject.city || 'N/A' }}</span>
          </div>
          <div class="grid-item">
            <span class="grid-item-label">State</span>
            <span class="grid-item-val">{{ selectedProject.state || 'N/A' }}</span>
          </div>
          <div class="grid-item">
            <span class="grid-item-label">Country</span>
            <span class="grid-item-val">{{ selectedProject.country || 'India' }}</span>
          </div>
        </div>
      </div>

      <div class="drawer-section">
        <h4>Key Personnel</h4>
        <div class="drawer-grid">
          <div class="grid-item">
            <span class="grid-item-label">Client Representative</span>
            <span class="grid-item-val">{{ selectedProject.client?.name || 'N/A' }}</span>
          </div>
          <div class="grid-item">
            <span class="grid-item-label">Client Email</span>
            <span class="grid-item-val" style="font-size: 12px; word-break: break-all;">{{ selectedProject.client?.email || 'N/A' }}</span>
          </div>
          <div class="grid-item">
            <span class="grid-item-label">Coordinator</span>
            <span class="grid-item-val">{{ selectedProject.coordinator?.name || 'N/A' }}</span>
          </div>
          <div class="grid-item">
            <span class="grid-item-label">Auditor</span>
            <span class="grid-item-val">{{ selectedProject.auditor?.name || 'N/A' }}</span>
          </div>
        </div>
      </div>

      <div class="drawer-section">
        <h4>Timeline & Submissions</h4>
        <div class="drawer-grid">
          <div class="grid-item">
            <span class="grid-item-label">Registered Date</span>
            <span class="grid-item-val">{{ formatDate(selectedProject.registered_date) }}</span>
          </div>
          <div class="grid-item">
            <span class="grid-item-label">Initiated Date</span>
            <span class="grid-item-val">{{ formatDate(selectedProject.initiated_date) }}</span>
          </div>
          <div class="grid-item">
            <span class="grid-item-label">Submitted Date</span>
            <span class="grid-item-val">{{ formatDate(selectedProject.submitted_date) }}</span>
          </div>
          <div class="grid-item">
            <span class="grid-item-label">Certification Date</span>
            <span class="grid-item-val">{{ formatDate(selectedProject.certification_date) }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="drawer-footer">
      <button class="retry-button" style="width: 100%; margin-top: 0;" (click)="closeDrawer()">Close Details</button>
    </div>
  </div>
</div>
